export const masterPlatypusPool = '0x7125b4211357d7c3a90f796c956c12c681146ebb';
export const tokenPerSecUSDCAddress =
  '0x032e09C819ed14314eD62Ea91c41151A228BdAb4';
export const tokenPerSecMoneyAddress =
  '0x77286ac09F4e0b7E6D37B4B77cd2D0Fb6b49323D';

export const tvlUSDCAddress = '0x551C259Bf4D88edFdAbb04179342a73dAa759583';
export const tvlMoneyAddress = '0xE08947eE864Af325D9F98743B3b905875Ae0Ec99';
